import React, { useState } from 'react';

import StudioShell from './components/StudioShell';
import { useStudio2Data } from './live/useStudio2Data';
import './studio2.css';

/**
 * Trainer (cohort) entry point for the Analysis Studio. Owns the focused-player
 * selection — the cohort data hook is parameterised by it (the focused player's
 * report + blotter are the only per-player enrichments) — and hands the
 * assembled cohort to the shared `StudioShell` in 'cohort' mode. The per-player
 * trainee view is `AnalysisStudioSelf`, which renders the same shell in 'self'
 * mode off `useSelfStudioData`.
 */
const AnalysisStudioLive: React.FC = () => {
  // No initial selection — the shell snaps to the first player once the real
  // roster loads (there is no mock roster to seed from).
  const [selectedId, setSelectedId] = useState<number | null>(null);

  // Live data source — real session/players assembled into the studio shapes.
  const { players, session, groupReports, isReady } = useStudio2Data(
    selectedId ?? undefined,
  );

  return (
    <StudioShell
      mode="cohort"
      players={players}
      session={session}
      groupReports={groupReports}
      isReady={isReady}
      selectedId={selectedId}
      onSelect={setSelectedId}
    />
  );
};

export default AnalysisStudioLive;
